export const QUESTION_TYPE = {
    TextQuestion: "escrita",
    SingleQuestion: "unica",
    MultiQuestion: "multiple",
    Info: "information"
}

export const GAMEMODE = {
    SEQUENTIAL: "sequential",
    FREEDOM: "freedom",
}

export const VIEW_COUNT_DURATION = 800;

export const VIDEOQUIZ_SOUNDS = {
    WRITE: "write",
    DELETE: "delete",
    SUBMIT: "submit",
    CHARGE: "charge",
    MOVE: "move",
}

export const NAME_INPUT = "options";

export const IS_STAGING = window.location.hostname.includes('dev.educaplay.com');
